import React from 'react';
import { StyledTimelineItem, TimelineContent, TimelineBefore, LineArea, Dot, TimelineAfter } from './styles.js';

const TimelineItem = ({ before, after, customDot, variation = 'neutral', orientation, }) => {
    return (React.createElement(StyledTimelineItem, { orientation: orientation },
        React.createElement(TimelineContent, { orientation: orientation },
            React.createElement(TimelineBefore, { orientation: orientation }, before),
            React.createElement(LineArea, { orientation: orientation }, customDot ? customDot : React.createElement(Dot, { variation: variation })),
            React.createElement(TimelineAfter, { orientation: orientation }, after))));
};

export { TimelineItem as default };
